export default __webpack_public_path__ + "static/reed-3-1770c054e38cec98c93a70997768a594.png";